import { useState } from "react";
// types
import { TMainPageLayoutV3 } from "../type";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import TBaseReduxStoreState from "@/core/types/TBaseReduxStoreState";
import TClientLanguage from "@/core/types/TClientLanguage";
import clsx from "clsx";


const MNPG064 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG064.rendered: ", props);

    const languages:TBaseReduxStoreState<TClientLanguage[]|null> = useSelector((state:any) => state.LanguageStore.list, shallowEqual);
    const languageCode = useSelector((state:any) => state.CoreStore.languageCode?.payload, shallowEqual);

    const navigate = useNavigate();
    const location = useLocation();

    const [languageToggle, setLanguageToggle] = useState(false);

    const handleLanguage = () => { setLanguageToggle(!languageToggle) }
    const closeLanguage = () => { setLanguageToggle(false) }

    const reloadPage = ( twoLetterISOName:string ) => {
        
        try {
            let pathnameArray = location.pathname?.split("/")?.filter((item:any) => item);
            let newPathname:string = ""; 
    
            if ( pathnameArray.length > 0 ) {
                pathnameArray[0] = twoLetterISOName;
                newPathname = `/${pathnameArray.join("/")}`;
            }
    
            navigate(newPathname, { replace: true });
            window.location.reload(); 
        } catch( ex ) {
            console.error(ex);
        }

    }

    return (
        <>
            <button
                className="language-trigger language tw-uppercase d-none d-md-block"
                onClick={handleLanguage}
                aria-label="Language Selector"
            >
                {(languages?.payload && languages.payload.find((item) => item.twoLetterISOName === languageCode)?.twoLetterISOName)||""}
            </button>

            <div
                className={clsx("language-wrap", {"open":languageToggle})}
                onClick={closeLanguage}
            >
                <div className="language-inner">
                    <i
                        className="fas fa-times language-close"
                        id="language-close"
                        onClick={closeLanguage}
                    />
                    <div className="language-cell">
                        <div className="language-field-holder">
                            {
                                languages?.payload && languages.payload.map((item) => (<p key={item.id}><Link to={`/${item.twoLetterISOName}`} replace onClick={() => { reloadPage(item.twoLetterISOName) }}>{item.name}</Link></p>))
                            }
                        </div>
                    </div>
                </div>
            </div>
      </>
    )
}

export default MNPG064;
